<template>
  <v-data-table
    :loading="loadingOrders"
    :disabled="loadingOrders"
    :headers="orderHeaders"
    :items="orders"
    :items-per-page="15"
    class="elevation-1"
    @dblclick:row="onRowDoubleClick"
  >
    <template v-slot:top>
      <v-toolbar flat>
        <v-spacer></v-spacer>
        <!-- Pushes the button to the right -->
        <v-btn rounded dark color="primary" @click="$emit('refreshOrders')" class="sigfloButtonSmall text-capitalize"
          ><v-icon class="mr-4">mdi-refresh</v-icon>Refresh</v-btn
        >
      </v-toolbar>
    </template>
    <template v-slot:item.actions="{ item }">
      <v-btn
        rounded
        dark
        color="rgb(124, 64, 220)"
        class="elevation-0 sigfloButtonSmall text-capitalize"
        @click="$emit('loadOrder', item.id)"
        ><v-icon class="mr-4">mdi-magnify-scan</v-icon>View Order</v-btn
      >
    </template>
    <template v-slot:item.orderStatus="{ item }">
      <v-chip :color="getOrderChipColor(item)" dark>{{ item ? formatPascalCase(item.orderStatus) : '' }}</v-chip>
    </template>

    <template v-slot:item.shippingStatus="{ item }">
      <v-chip :color="getShippingChipColor(item)" dark>{{ item ? formatPascalCase(item.shippingStatus) : '' }}</v-chip>
    </template>
    <template v-slot:item.orderTotal="{ item }"> ${{ formatPrice(item.orderTotal) }} </template>
  </v-data-table>
</template>

<script>
  import { mapState } from 'vuex';
  export default {
    data() {
      return {
        loadingOrders: false,
        loadingOrder: false,
        orderHeaders: [
          { text: 'Order ID', value: 'id' },
          { text: 'Status', value: 'orderStatus' },
          { text: 'Shipping Status', value: 'shippingStatus' },
          { text: 'Order Total', value: 'orderTotal' },
          { text: '', value: 'actions', sortable: false }
        ]
      };
    },
    computed: {
      ...mapState(['app', 'order']),
      orders() {
        return this.order.orderList;
      }
    },
    methods: {
      /**
       * Returns the color class for a shipping chip based on the given status.
       *
       * @param {string} status - The status of the shipping.
       * @returns {string} The color class for the shipping chip.
       */
      getShippingChipColor(item) {
        if (!item || !item.shippingStatus) return 'transparent';
        switch (item.shippingStatus.toLowerCase()) {
          case 'complete':
            return 'green lighten-2';
          case 'inprocess':
            return 'yellow darken-2';
          case 'partial':
            return 'blue lighten-1';
          default:
            return 'grey darken-2';
        }
      },
      /**
       * Handles the double-click event on a row in the orders table.
       */
      onRowDoubleClick(event, row) {
        this.$emit('loadOrder', row.item.id);
      },
      /**
       * Returns the color class for the order chip based on the given status.
       *
       * @param {string} status - The status of the order.
       * @returns {string} The color class for the order chip.
       */
      getOrderChipColor(item) {
        if (!item || !item.orderStatus) return 'transparent';
        switch (item.orderStatus.toLowerCase()) {
          case 'converted':
            return 'grey darken-2';
          case 'approved':
            return 'blue darken-2';
          case 'fulfilled':
            return 'green lighten-2';
          default:
            return 'grey darken-2';
        }
      }
    }
  };
</script>

<style></style>
